import { render, staticRenderFns } from "./ServiceStatisticsView.vue?vue&type=template&id=48b94b72&scoped=true"
import script from "./ServiceStatisticsView.vue?vue&type=script&lang=js"
export * from "./ServiceStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b94b72",
  null
  
)

export default component.exports